import { render } from "./ArticleSection.vue?vue&type=template&id=8a1ced40&ts=true"
import script from "./ArticleSection.vue?vue&type=script&lang=ts"
export * from "./ArticleSection.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__